import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { FsHero } from '@/components/landing/fs-hero'
import { ScrollStory } from '@/components/landing/fs-scroll-story'
import { Stages } from '@/components/landing/fs-stages'
import { Showcase } from '@/components/landing/fs-showcase'
import { CaseStudies } from '@/components/landing/fs-case-studies'
import { NumbersSection } from '@/components/landing/numbers-section'
import { Faq } from '@/components/landing/fs-faq'
import { CtaSection } from '@/components/landing/cta-section'

const FullService: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Full-service integrations'
                description='FlowCraft pairs a powerful integration platform with a dedicated in-house team that scopes, builds, launches and supports every production workflow.'
            />

            <FsHero />

            <ScrollStory />

            <Stages />

            <Showcase />

            <CaseStudies />

            <NumbersSection />

            <Faq />

            <CtaSection
                title='Ready to connect your systems?'
                accent="Let's talk."
                actions={[
                    { label: 'Contact us', variant: 'primary', intent: 'contact' }
                ]}
            />
        </Layout>
    )
}

export default FullService
